import React, { useEffect, useState } from "react";
import MetaData from "../../layout/MetaData";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setVehicleName,saveUserAddressInfo, vehicleName, userAddressInfo } from "../../../redux/features/userAddressInfoSlice";

const CreateExportBooking = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
  
    const [bookingType, setBookingType] = useState("");
    const [loadType, setLoadType] = useState("Full Truck"); // Default value
    const [userProposedAmount, setUserProposedAmount] = useState("");
    const [adminProposedAmount, setAdminProposedAmount] = useState("");
    const [notes, setNotes] = useState("");
    const [startAddress, setStartAddress] = useState("");
    const [destinationAddress, setDestinationAddress] = useState("");
    const [startCity, setStartCity] = useState("");
    const [destinationCity, setDestinationCity] = useState("");
  
    const { userAddressInfo } = useSelector((state) => state.userAddressInfo);
  
    useEffect(() => {
      if (userAddressInfo) {
        setBookingType("Export");
        setAdminProposedAmount("")
        if (userAddressInfo?.loadType) {
          setLoadType(userAddressInfo.loadType);
        }       
        setUserProposedAmount(userAddressInfo?.userProposedAmount);
        setNotes(userAddressInfo?.notes);
        setStartAddress(userAddressInfo?.startAddress);
        setDestinationAddress(userAddressInfo?.destinationAddress);
        setStartCity(userAddressInfo?.startCity);
        setDestinationCity(userAddressInfo?.destinationCity);
      }
    }, [userAddressInfo]);
      
    const submiHandler = (e) => {
      e.preventDefault();
      dispatch(saveUserAddressInfo({notes, userProposedAmount, loadType, bookingType, startAddress, destinationAddress, startCity, destinationCity}));
      navigate("/select-address");
    };

  return (
   <>
      <MetaData title={"Create An Export Booking"} />
    <div className="row wrapper mb-5">
    <div className="col-10 col-lg-5">
      <form className="shadow rounded bg-body" onSubmit={submiHandler}>
      <h1 className="h1-mid">Export</h1>
      <br></br>
        <h3 className="mb-4">Create A Export Booking</h3>

            <div className="mb-3 col">
                <label htmlFor="loadType_field" className="form-label">
                  Load Type
                </label>
                <select
                  className="form-select"
                  id="loadType_field"
                  name="loadType"
                  required
                  defaultValue="Select A Load Type" // Default value set here
                  onChange={(e) => setLoadType(e.target.value)}                  
                >
                 <option value="Full Truck">Full Truck</option>
                 <option value="Sharing">Sharing</option>
                </select>
              </div> 

        <div className="mb-3">
          <label htmlFor="startAddress_field" className="form-label">
            Starting Address Detail
          </label>
          <input
            type="text"
            id="startAddress_field"
            className="form-control"
            name="startAddress"
            value={startAddress}
            onChange={(e) => setStartAddress(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="destinationAddress_field" className="form-label">
            Destination Address Detail
          </label>
          <input
            type="text"
            id="destinationAddress_field"
            className="form-control"
            name="destinationAddress"
            value={destinationAddress}
            onChange={(e) => setDestinationAddress(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="startCity_field" className="form-label">
            Start City 
          </label>
          <input
            type="text"
            id="startCity_field"
            className="form-control"
            name="startCity"
            value={startCity}
            required
            onChange={(e) => setStartCity(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="destinationCity_field" className="form-label">
          Destination City 
          </label>
          <input
            type="text"
            id="destinationCity_field"
            className="form-control"
            name="destinationCity"
            value={destinationCity}
            required
            onChange={(e) => setDestinationCity(e.target.value)}
          />
        </div>

        <div className="mb-3">
  <label htmlFor="userProposedAmount_field" className="form-label">
    Proposed Amount 
  </label>
  <div className="input-group">
    <span className="input-group-text">PKR</span>
    <input
      type="number"
      id="userProposedAmount_field"
      className="form-control"
      name="userProposedAmount_field"
      value={userProposedAmount}
      required
      onChange={(e) => setUserProposedAmount(e.target.value)}
    />
  </div>
</div>

      <div className="mb-3">
              <label htmlFor="notes_field" className="form-label">
                Notes
              </label>
              <textarea
                className="form-control"
                id="notes_field"
                rows="4"
                name="notes_field"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                >
                </textarea>
            </div>

        
        <button id="shipping_btn" type="submit" className="btn w-100 py-2">
          CONTINUE
        </button>
      </form>
    </div>
  </div>
  </>
  )
}

export default CreateExportBooking
